import React, {useEffect, useState} from 'react'
import {Heading, WrapCard, ManagerCard, Card, NoData} from './styles'
import {NoManager, VerticalDotsIcon} from '../../utils/icons'
import {CommonButton, CommonButtonBorder} from '../common/commonStyles'
import {DownAngleV2} from '../SocialFeedsV2/styles'
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import AddManager from './addManager'
import RemoveManager from './removeManager'
import {ImageUrl} from '../../utils/constants'
import { GetLocationsWithManagers } from '../../redux/constants/apiConstants'
import { fetchApi, getInitials } from '../../utils/methods'
import { toast } from 'react-toastify'
import { NameInitials } from '../Manager/styles';
import PropTypes from 'prop-types';

const Location = ({companyId, history}) => {
  const [showAddManager, setHideShow]=useState(false);
  const [showRemoveManager, setShowRemove]=useState(false);
  const [locationsData, setLocationsData]= useState([]);
  const [getSelectedId, setSelectedId]=useState('');
  const [getRemoveData, setRemoveData]=useState([])

  useEffect(()=>{
    getManagerDataByLocation()
  },[])

  const getManagerDataByLocation = async()=>{
    try {
      const res = await fetchApi(`${GetLocationsWithManagers + "/" + companyId}`, "GET");
      if(res.status === "success"){
        setLocationsData(res.data)
      }else{
        // toast.error(error.message);
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  const onSelectDepartment = (value,id) =>{
    setHideShow(value)
    setSelectedId(id)
  }

  const onSelectRemovePopup = (value, data)=>{
    setShowRemove(value)
    setRemoveData(data)
  }

  const NodataCard= () =>(
    <NoData>
      <div className='image'>{NoManager()}</div>
      <div className='no-data'>Add managers to your locations</div>
      <div className='subtext'>Create departments and locations directly from the People page to easily assign managers and organize your company structure.</div>
      <div className='button'>
        <CommonButton onClick={()=>history.push('/company/people')}>Go to People Page</CommonButton>
      </div>
    </NoData>
  ) 
  return(
    <>
      <Heading> {locationsData?.managersCount} Managers <span>You can assign up to 3 managers to each location.</span></Heading>
      <WrapCard>
        {locationsData?.locations?.length === 0?NodataCard():locationsData?.locations?.map((data,index)=>
          <div className='user-card' key={index}>
            <ManagerCard>
              <div className='heading'>
                <NameInitials id="name-initials" isWidth="60px" isHeight="60px">
                  {getInitials(data?.city)}
                </NameInitials>
                <div className='title'>{data?.city}</div>
                <div className='menu'>
                  <DownAngleV2  feed padding="0 16px" marginL="-140px">
                    <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>} >
                      <Dropdown.Item onClick={()=>onSelectRemovePopup(true,data)}>
                        {("Remove Manager")}
                      </Dropdown.Item>
                    </DropdownButton>
                  </DownAngleV2>
                </div>
              </div>
              <div className='wrap-user'>
                {data?.managers?.length>0?
                  data?.managers?.map((manager,index)=>
                    (<Card key={index}>
                      {
                        manager?.profile_image !== "profile-Image/default.png" ? ( <div className="image"> <img src={`${ImageUrl}/${manager?.profile_image}`} /> </div> ):
                          <NameInitials id="name-initials">
                            {getInitials(manager?.fname)}{getInitials(manager?.lname)}
                          </NameInitials>  
                      }
                      <div className='wrap'>
                        <div className='name'>{manager?.fname}{" "}{manager?.lname} </div>
                        <div className='location'>{manager?.department}</div>
                      </div>
                    </Card>)):null}
                {data?.managers?.length<3?
                  <div className='button-wrap'>
                    <CommonButtonBorder onClick={()=>onSelectDepartment(true, data.id)}>Add Manager</CommonButtonBorder>
                  </div>:data?.managers?.length===0&&
                  <div className='button-wrap'>
                    <CommonButtonBorder onClick={()=>onSelectDepartment(true, data.id)}>Add Manager</CommonButtonBorder>
                  </div>
                }
              </div>
            </ManagerCard>
          </div>
        )}
        {showAddManager&&<AddManager showModal={showAddManager} setHideShow={onSelectDepartment} companyId={companyId} getSelectedId={getSelectedId} getManagerDataByDepartment={getManagerDataByLocation} type={'location'}/>}
        {showRemoveManager&&<RemoveManager showModal={showRemoveManager} setHideShow={onSelectRemovePopup} companyId={companyId} getSelectedId={getSelectedId} getRemoveData={getRemoveData} getManagerDataByDepartment={getManagerDataByLocation} type={'location'}/>}
      </WrapCard>
    </>
  )
}

Location.propTypes = {
  departmentData: PropTypes.array,
  history: PropTypes.object,
  companyId: PropTypes.number,
  getManagerDataByDepartment: PropTypes.func
};

export default Location